module.exports = __webpack_public_path__ + "img/intro-bg.af00bfdd.png";